import { useState, useEffect, useRef } from "react";
import { FIRMWARE_UPDATE_DURATION_MS } from "../constants/app";
import { FIRMWARE_UPDATE_STEPS } from "../constants/firmware";

// Simulates firmware update progress over FIRMWARE_UPDATE_DURATION_MS.
// isActive: start/stop the timer. onComplete: called once when 100% is reached.
export function useFirmwareProgress(isActive, onComplete) {
  const [percent, setPercent] = useState(0);
  const [step, setStep] = useState(0);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    if (!isActive) {
      setPercent(0);
      setStep(0);
      return;
    }
    const stepsCount = FIRMWARE_UPDATE_STEPS.length;
    const intervalMs = FIRMWARE_UPDATE_DURATION_MS / stepsCount;
    let current = 0;
    const timer = setInterval(() => {
      current += 1;
      setStep(Math.min(current, stepsCount - 1));
      setPercent(Math.min(100, Math.round((current / stepsCount) * 100)));
      if (current >= stepsCount) {
        clearInterval(timer);
        onCompleteRef.current?.();
      }
    }, intervalMs);
    return () => clearInterval(timer);
  }, [isActive]);

  return { percent, step };
}
